import { Link, useLocation } from 'react-router-dom'
import { Music2, PlaySquare, Music } from 'lucide-react'

const SERVICES = [
    { to: '/tiktoksellpage', label: 'TikTok', Icon: Music2 },
    { to: '/youtube', label: 'YouTube', Icon: PlaySquare },
    { to: '/spotify', label: 'Spotify', Icon: Music },
]

export default function LandingHeader() {
    const { pathname } = useLocation()
    return (
        <div className="relative">
            <div className="absolute left-[-356px] top-[-177px] z-10 h-[500px] w-[500px] rounded-full bg-purple-500 opacity-50 blur-[250px]" />
            <div className="mx-auto flex max-w-[1312px] items-center justify-between gap-4 overflow-auto px-4 py-6">
                <Link to="/" className="shrink-0">
                    <img
                        src="/images/logo.png"
                        alt="Logo"
                        className="h-10 w-[166px]"
                    />
                </Link>

                <nav className="flex items-center gap-1 sm:gap-2">
                    {SERVICES.map(({ to, label, Icon }) => {
                        const active = pathname === to
                        return (
                            <Link
                                key={to}
                                to={to}
                                className={`inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-xs font-semibold transition sm:text-sm ${
                                    active
                                        ? 'bg-slate-900 text-white'
                                        : 'text-slate-700 hover:bg-slate-100'
                                }`}
                            >
                                <Icon className="h-4 w-4" />
                                <span className="hidden sm:inline">{label}</span>
                            </Link>
                        )
                    })}
                </nav>

                <Link
                    to="/dashboard"
                    className="hidden h-[48px] w-[138px] shrink-0 items-center justify-center rounded-lg text-base font-medium tracking-wide text-slate-900 outline outline-2 outline-offset-[-2px] outline-slate-900 transition-colors duration-300 ease-in-out hover:bg-purple-500 hover:text-white hover:outline-0 md:flex"
                >
                    Dashboard
                </Link>
            </div>
        </div>
    )
}
